import { Router } from "@angular/router";
import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngstack/translate";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { IResendCode } from "src/app/interfaces/resendCode";
import { ErrorsService } from "src/app/services/common/errors.service";
import { AccountService } from "src/app/services/http/business/account/account.service";
import { Title } from "@angular/platform-browser";
import { environment } from "src/environments/environment";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: "app-demand-code",
  templateUrl: "./demand-code.component.html",
  styleUrls: ["./demand-code.component.css"],
  providers: [ErrorsService]
})
export class DemandCodeComponent implements OnInit {
  demandCodeForm: FormGroup;
  errors = new Array();
  errObject: any;
  param: any;
  errorList: IError[] = [];

  constructor(
    private route: Router,
    private fb: FormBuilder,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private titleService: Title,
    private accountService: AccountService
  ) {}

  ngOnInit() {
    this.titleService.setTitle(environment.siteTitle);
    this.demandCodeForm = this.fb.group({
      NationalCode: [
        null,
        Validators.compose([
          Validators.required,
          Validators.pattern("^[0-9]*$"),
          Validators.minLength(10),
          Validators.maxLength(12)
        ])
      ]
    });
  }
  submit(form: IResendCode) {
    this.errors = new Array();
    this.accountService.resendCode(form).subscribe(
      () => {
        this.route.navigate(["forgottenPass"]);
      },
      error => {
        // this.errObject = this.errorService.getError(error);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(error);
        this.errorList = this.errorService.getErrorList(error.error);
      }
    );
  }
}
